/**
 * websock全局方法
 * 
 */
import router from '../../router';
const websocketStore = {
    state: {
        websock: null,
        eventlist:[],
        mailShow:false,
        showPFM:0,
        showExecute:false,
        downloadTip:false
    },
    
    getters: {},
    mutations: {
        websock_int(state,url) {
            state.websock = new WebSocket(url);
            state.websock.onopen = function () {
                let positionId = window.localStorage.getItem('positionId') //获取 本地存储的positionId
                let token=window.localStorage.getItem("token");
                let tokenVal ={
                    token:token,
                    userId:positionId
                };  //传递参数要是对象
                console.log(tokenVal);
                tokenVal.token = String(token); //key值要是字符串
                tokenVal.userId = String(tokenVal.userId); //key值要是字符串
                tokenVal = JSON.stringify(tokenVal); //传递前要转换成json格式数据
                state.websock.send(tokenVal);

                console.log("连接成功！");
            }
            state.websock.onmessage = function (callBack) {
                console.log("ws接收！");
                console.log(callBack);
                var receive = [];
                receive = receive.concat(Array.from(new Uint8Array(callBack.data)));
                state.eventlist.push({
                    receive
                })
                let obj = JSON.parse(callBack.data)
                console.log(obj)

                var options = {
                    dir: "auto", // 文字方向
                    body: obj.msg, // 通知主体
                    requireInteraction: true, // 不自动关闭通知
                    // 通知图标 
                    icon: "static/img/img.jpg",
                    renotify:false,//是否替换之前的通知
                    silent:true,//通知出现的时候，是否要有声音
                    sound:'https://bs.xcang.xyz/voice/notice_test.mp3',//音频地址。表示通知出现要播放的声音资源。
                    // image:'static/img/img.jpg',
                    tag: obj.type,//代表通知的一个识别标签，相同tag时只会打开同一个通知窗口。
                }
                if(callBack.data){
                    notifyMe('济邦科技有限公司',options);
                }

            }
            state.websock.οnerrοr=function(e) { //错误
                console.log("ws错误!");
                console.log(e);
            }
            state.websock.onclose=function(e) { //关闭
                console.log("ws关闭！");
                console.log(e);
            }
            state.websock.binaryType = "arraybuffer";
        },
        websock_send(state, p) {
            console.log("ws发送！");
            p.type = String(p.type); //key值要是字符串
            p.userId = String(p.userId); //key值要是字符串
            p = JSON.stringify(p); //传递前要转换成json格式数据
            state.websock.send(p);
            console.log('p传值',p)
        },
        showMailDialog(state,show){
            state.mailShow = show
        },
        showPerformance(state,p){
            state.showPFM = p;
        },
        openExecute(state,p){
            state.showExecute = p
        },
        showDownloadTip(state,p){
            state.downloadTip = p
        }
       
    },
    actions: {
        websock_int({commit},url) {
            commit('websock_int',url)
        },
        websock_send({commit}, p) {
            commit('websock_send', p)
        }
    }
}


function notifyMe(title, options) {
    // 先检查浏览器是否支持
    if (!window.Notification) {
        console.log('浏览器不支持通知');
        // 提示不支持系统通知
        this.$alert('您的浏览器不支持系统通知,建议使用Chrome浏览！', '操作提示', {confirmButtonText: '确定',});
    } else {
       // 检查用户曾经是否同意接受通知
       if (Notification.permission === 'granted') {
           var notification = new Notification(title, options); // 显示通知
            
           let type = notification.tag
           console.log(type)
           //进入我的任务页面
           notification.onclick=e=>{
                if(type=='1'){
                    router.push('/myTaskList');
                }else if(type=='2'){
                    websocketStore.state.drawerXx = true;
                    console.log(websocketStore.state.drawerXx)
                    router.push('/companymanage');
                }else if(type=='3'){
                    router.push('/addressChannel');
                }else if(type=='4'){
                    router.push('/orderAudit');
                }else if(type=='5'){
                    router.push('/orderAudit');
                }else if(type=='6'){
                    router.push('/myRenewalList');
                }else if(type=='7'){
                   router.push('/myBookKeepingList');
                }else if(type=='8'){
                    router.push('/orderAudit');
                }else if(type=='9'){
                    router.push('/invoicemanagement');
                }else if(!type){
                    websocketStore.state.drawerXx = true;
                    router.push('/myTaskList');
                }
           } 
       } else if (Notification.permission === 'default') {
          // 用户还未选择，可以询问用户是否同意发送通知
          Notification.requestPermission().then(permission => {
              if (permission === 'granted') {
                  console.log('用户同意授权');
                  var notification = new Notification(title, options); // 显示通知
              } else if (permission === 'default') {
                  console.warn('用户关闭授权 未刷新页面之前 可以再次请求授权');
              } else {
                  // denied
                  console.log('用户拒绝授权 不能显示通知');
              }
          });
      } else {
        // denied 用户拒绝
        console.log('用户曾经拒绝显示通知');
      }
    }
  }













function makeByte(p){
    var bytesMethod = stringToByte(p.method);
 
    var bytes = stringToByte(JSON.stringify(p.jsonData));
 
    var headLenth = 6;
    var bodyLenth = bytes.length + bytesMethod.length + 2 + 2;
    var buffer = new ArrayBuffer(headLenth + bodyLenth);
    var view = new DataView(buffer);
 
    var count = 0;
    //包头
    view.setInt16(count, p.type);//消息类型2
    count += 2;
    view.setUint32(count, bodyLenth);//包体大小4
    count += 4;
    //包体
 
    view.setInt16(count, 1);//序列化类型2
    count += 2;
    view.setInt16(count, bytesMethod.length);//方法字符大小2
    count += 2;
    for (var i = 0; i < bytesMethod.length; i++) {
        view.setUint8(count, bytesMethod[i]);
        count++;
    }
    for (var i = 0; i < bytes.length; i++) {
        view.setUint8(count, bytes[i]);
        count++;
    }
    return view;
}
 
 
function stringToByte(str) {
    var bytes = new Array();
    var len, c;
    len = str.length;
    for (var i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if (c >= 0x010000 && c <= 0x10FFFF) {
            bytes.push(((c >> 18) & 0x07) | 0xF0);
            bytes.push(((c >> 12) & 0x3F) | 0x80);
            bytes.push(((c >> 6) & 0x3F) | 0x80);
            bytes.push((c & 0x3F) | 0x80);
        } else if (c >= 0x000800 && c <= 0x00FFFF) {
            bytes.push(((c >> 12) & 0x0F) | 0xE0);
            bytes.push(((c >> 6) & 0x3F) | 0x80);
            bytes.push((c & 0x3F) | 0x80);
        } else if (c >= 0x000080 && c <= 0x0007FF) {
            bytes.push(((c >> 6) & 0x1F) | 0xC0);
            bytes.push((c & 0x3F) | 0x80);
        } else {
            bytes.push(c & 0xFF);
        }
    }
    return bytes;
 
 
}
 
 
function byteToString(arr) {
    if (typeof arr === 'string') {
        return arr;
    }
    var str = '',
        _arr = arr;
    for (var i = 0; i < _arr.length; i++) {
        var one = _arr[i].toString(2),
            v = one.match(/^1+?(?=0)/);
        if (v && one.length == 8) {
            var bytesLength = v[0].length;
            var store = _arr[i].toString(2).slice(7 - bytesLength);
            for (var st = 1; st < bytesLength; st++) {
                store += _arr[st + i].toString(2).slice(2);
            }
            str += String.fromCharCode(parseInt(store, 2));
            i += bytesLength - 1;
        } else {
            str += String.fromCharCode(_arr[i]);
        }
    }
    return str;
}

export default websocketStore





// WEBPACK FOOTER //
// ./src/store/components/websocketStore.js